"use client";

import "./Sitemap.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";

// 1. Creamos un nuevo sub-componente que se encarga de renderizar 1 enlace 
// y verificar si tiene "hijos" (sub-páginas)
function SitemapItem({
  item
}) {
  return <li className="flex flex-col gap-2">
      <Link to={item.href || "#"} className="text-lg text-foreground/90 hover:text-primary transition-colors duration-300 relative inline-block group w-fit">
        <span className="relative">
          {item.label}
          <span className="absolute left-0 -bottom-1 h-px w-0 bg-primary transition-all duration-300 group-hover:w-full" />
        </span>
      </Link>

      {/* Aquí está la magia: Si tiene hijos, creamos una sub-lista y volvemos a llamar al componente */}
      {item.children && item.children.length > 0 && <ul className="pl-8 mt-2 flex flex-col gap-3 border-l-2 border-muted/30">
          {item.children.map(child => <SitemapItem key={child.id} item={child} />)}
        </ul>}
    </li>;
}

// 2. El consumidor del menú ahora usa nuestro nuevo SitemapItem
function SitemapConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 flex flex-col gap-4">
        <div className="h-4 w-48 bg-muted/40 animate-pulse" />
        <div className="h-4 w-64 bg-muted/40 animate-pulse" />
        <div className="h-4 w-52 bg-muted/40 animate-pulse" />
      </div>;
  }
  return <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 min-h-[50vh]">
      <h1 className="text-4xl font-extrabold mb-10 text-foreground">Sitemap</h1>
      <ul className="flex flex-col gap-6">
        {menuItems.map(item => <SitemapItem key={item.id} item={item} />)}
      </ul>
    </div>;
}
export default function SitemapPage() {
  return <div>
      <Header />
      {/* Recuerda asegurarte de que el menu_id sea el correcto */}
      <MenuProvider menu_id="14"> 
        <SitemapConsumer />
      </MenuProvider>
      <Footer />
    </div>;
}